import React from 'react';
import {
  Box,
  BoxProps,
  Card,
  CardProps,
  Collapse,
  CollapseProps,
  Divider,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export type ExpandableCardProps = React.PropsWithChildren<{
  header: React.ReactNode;
  expanded?: boolean;
  defaultExpanded?: boolean;
  onChangeExpanded?: () => void;
  cardProps?: CardProps;
  collapseProps?: Omit<CollapseProps, 'in'>;
  extra?: React.ReactNode;
  footer?: React.ReactNode;
  uncollapsibleProps?: BoxProps;
  collapsibleProps?: {
    addEndListener: () => void;
  };
}>;

export const ExpandableCard = ({
  header,
  expanded,
  defaultExpanded,
  onChangeExpanded,
  children,
  cardProps,
  collapseProps,
  extra,
  footer,
  uncollapsibleProps,
  collapsibleProps,
}: ExpandableCardProps) => {
  const [_expanded, setExpanded] = React.useState(defaultExpanded ?? true);
  const isExpanded = typeof expanded !== 'undefined' ? expanded : _expanded;
  const handleChangeExpanded = () => {
    setExpanded(!_expanded);
    onChangeExpanded?.();
  };
  return (
    <Card {...cardProps}>
      <Box {...uncollapsibleProps}>
        <Box
          px={3}
          py={2}
          sx={{ cursor: 'pointer' }}
          onClick={handleChangeExpanded}
          display={'flex'}
          alignItems={'center'}
        >
          <Box flex={0} mr={1} display="flex" alignItems="center">
            {isExpanded ? (
              <ArrowDropDownIcon sx={{ fontSize: '1.5rem' }} />
            ) : (
              <ArrowRightIcon sx={{ fontSize: '1.5rem' }} />
            )}
          </Box>
          <Box flex={1}>{header}</Box>
        </Box>
        <Divider />
        {extra}
      </Box>
      <Collapse
        analyticsname={cardProps?.id}
        {...collapseProps}
        in={isExpanded}
        addEndListener={(node: HTMLElement, done: () => void) => {
          collapsibleProps?.addEndListener?.();
          done();
        }}
      >
        <Box px={3} py={2}>
          {children}
        </Box>
        {footer}
      </Collapse>
    </Card>
  );
};
